var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHealthSafetyMarker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 216 216",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-4{fill:#fff;}.cls-2,.cls-5{fill:#af0e38;stroke:#af0e38;}.cls-2,.cls-3,.cls-4,.cls-5{stroke-miterlimit:10;}.cls-2,.cls-4{stroke-width:5px;}.cls-3{fill:none;stroke:#112034;stroke-linecap:round;stroke-width:6.62px;}.cls-4{stroke:#4a5d79;}.cls-5{stroke-width:2.93px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 108,
    cy: 89.16,
    r: 54.23
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M173.68,93.19A65.68,65.68,0,1,0,64.5,142.39l37.6,43.51a7.52,7.52,0,0,0,11.37,0l36.34-42.05A65.56,65.56,0,0,0,173.68,93.19ZM108,36.75A54.78,54.78,0,1,1,53.22,91.53,54.79,54.79,0,0,1,108,36.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M108.54,101.89H70.24a2,2,0,0,0-.43,0A4.94,4.94,0,0,0,66,104.87c-.69,1.89-.08,3.86,2.41,5.32a1.79,1.79,0,0,0,.91.24H100.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M97.05,65A35.22,35.22,0,0,0,83.54,73.3s-6.66,6.75-8.11,15.49a67.21,67.21,0,0,0-.68,7.74c-.06,2,0,3.63,0,4.77"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M97.73,79.26V66.15a10.45,10.45,0,0,1,4-8.34c3.08-2.3,6.69-2.35,8.79-2.38s5.19-.06,8.11,1.79a10.7,10.7,0,0,1,4.73,8.34v13.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M124,65a35.09,35.09,0,0,1,13.51,8.34h0A30.17,30.17,0,0,1,145.71,87"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M129.69,77.62,108.44,83a69.66,69.66,0,0,0-.17,10c.43,8,1,16.45,7,23.16a20,20,0,0,0,8,5.64,18.4,18.4,0,0,0,6.27,1.09,18.85,18.85,0,0,0,5.92-1.09,21,21,0,0,0,8.53-5.64c5.65-6,5.93-13.81,6.27-23.16A78.31,78.31,0,0,0,150,83Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 127.42,
    y: 88.08,
    width: 4.61,
    height: 22,
    rx: 0.11
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 127.42,
    y: 88.08,
    width: 4.61,
    height: 22,
    rx: 0.11,
    transform: "translate(30.64 228.81) rotate(-90)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHealthSafetyMarker);
export default __webpack_public_path__ + "static/media/Health&Safety_Marker.ec86a3fd5be56055bb791c7102ecfd0c.svg";
export { ForwardRef as ReactComponent };